import { gql } from '@apollo/client';
const CONSTRUCT_VARIANTS = gql `
  mutation ConstructVariants(
    $productId: ID!
    $colorsStr: String
    $sizesStr: String
    $chainColorsStr: String
    $tapeColorsStr: String
    $sliderColorsStr: String
  ) {
    constructVariantsToAdd(
      productId: $productId
      colorsStr: $colorsStr
      sizesStr: $sizesStr
      chainColorsStr: $chainColorsStr
      tapeColorsStr: $tapeColorsStr
      sliderColorsStr: $sliderColorsStr
    ) {
      id
      constructionSuccessful
      variantsToAdd {
        id
        color
        chainColor
        tapeColor
        sliderColor
        size
        toCreate
      }
      toCreateCount
      toCreateLimit
    }
  }
`;
export default CONSTRUCT_VARIANTS;
